import { isUndefined } from 'lodash-es';

import { HoneycombDownloadDataButton } from './buttons/HoneycombDownloadDataButton.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { A11yToolbarTabIndex } from '../../../core/types/toolbar.js';
import { useHoneycombData } from '../../hooks/use-honeycomb-data.js';
import { useHoneycombToolbarConfig } from '../../hooks/use-honeycomb-toolbar-config.js';
import { useHoneycombOverlayMouseInBoundsState } from '../../store/selectors.js';
import { useSetStateTooltip } from '../../store/store.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const HoneycombToolbar = () => {
  const mouseInBounds = useHoneycombOverlayMouseInBoundsState();
  const setTooltipState = useSetStateTooltip();

  const toolbarConfig = useHoneycombToolbarConfig();

  const isDownloadEnabled = toolbarConfig?.downloadData?.enabled ?? false;
  const defaultToolbarPlacement = 'top-right';

  const handleMouseEnter = () => {
    setTooltipState({
      enabled: false,
      pinned: false,
    });
  };

  const handleMouseLeave = () => {
    setTooltipState({
      enabled: true,
    });
  };

  const rawData = useHoneycombData();

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => buildAndDownloadCsv(rawData);

  const showDefaultToolbarDownloadButton =
    isDownloadEnabled && !toolbarConfig?.intents;

  const showToolbar =
    !isUndefined(toolbarConfig) &&
    (isDownloadEnabled || !!toolbarConfig?.intents);

  const initialA11yState: A11yToolbarTabIndex[] =
    showDefaultToolbarDownloadButton ? [{ download: 0 }] : [{ intent: 0 }];

  return showToolbar ? (
    <ChartToolbarRenderer
      visible={mouseInBounds && showToolbar}
      collapsed={toolbarConfig.collapsed}
      draggable={toolbarConfig.draggable}
      placement={toolbarConfig.placement || defaultToolbarPlacement}
      initialA11yState={initialA11yState}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      menuDisplayMode={'never'}
      isDownloadEnabled={isDownloadEnabled}
      intents={toolbarConfig?.intents}
      handleDownloadDataToolbar={handleDownloadDataToolbar}
      DownloadButton={() => <HoneycombDownloadDataButton />}
    >
      {showDefaultToolbarDownloadButton && <HoneycombDownloadDataButton />}
    </ChartToolbarRenderer>
  ) : null;
};

HoneycombToolbar['displayName'] = 'HoneycombToolbar';
